import { env } from 'utils/envManager'

import type { GetActivePurchase } from '../types/activePurchases.types'
import type { GetPurchaseProps } from '../types/purchases.types'

export const getActivePurchases = ({
	token,
	languageISO,
	countryISO,
	channel,
}: GetPurchaseProps): Promise<GetActivePurchase[]> =>
	fetch(
		`${env.NEXT_PUBLIC_SITE_BASE_URL}/ws-my-purchases/v2/${channel}/purchases/active`,
		{
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
				'Accept-Language': `${languageISO}-${countryISO}`,
			},
			next: { revalidate: 0 },
		}
	).then((response: Response) => {
		if (response.ok) {
			return response.json()
		}
		throw new Error()
	})
